<template>
  <div id="cash-log-closure-list">
    <div class="list">
      <table>
        <thead v-if="isDesktop">
          <tr>
            <th>{{ $t('ID') }}</th>
            <th>{{ $t('DATE') }}</th>
            <th>{{ $t('BALANCE') }}</th>
            <th>{{ $t('NOTES') }}</th>
            <th>{{ $t('FUND') }}</th>
            <th class="more"></th>
          </tr>
        </thead>
        <tbody>
          <tr :key="item.id" v-for="item in items">
            <td>
              <div class="mobile-header" v-if="!isDesktop">{{ $t('ID') }}:</div>
              <div>{{ item.id }}</div>
            </td>
            <td>
              <div class="mobile-header" v-if="!isDesktop">{{ $t('DATE') }}:</div>
              <div>{{ moment(item.closureDate, DATE_FORMAT).format('DD/MM/YYYY') }}</div>
            </td>
            <td>
              <div class="mobile-header" v-if="!isDesktop">{{ $t('BALANCE') }}:</div>
              <div>{{ addCommas(item.balance) }}</div>
            </td>
            <td>
              <div class="mobile-header" style="white-space: normal;" v-if="!isDesktop">{{ $t('NOTES') }}:</div>
              <p class="wrap">{{ item.notes }}</p>
            </td>
            <td>
              <div class="mobile-header" v-if="!isDesktop">{{ $t('FUND') }}:</div>
              <div>{{ item.fund.name }}</div>
            </td>
            <td>
              <div class="mobile-header" v-if="!isDesktop">{{ $t('ACTION') }}:</div>
              <action-menu :item="item" @action-made="getItems" v-if="isHeadAccountant" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <pagination
      :page="filters.page"
      :pageSize="filters.pageSize"
      :total="total"
      @pageSizeChange="changePageSize"
      @pageChange="changePage"
    />
  </div>
</template>

<script>
import { computed, onUnmounted, onMounted, watch } from '@vue/composition-api';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import moment from 'moment';

import Pagination from '@/components/Pagination';

import { DATE_FORMAT, PERMISSIONS } from '@/consts';
import { addCommas } from '@/helpers';
import { hasPermissions } from '@/helpers/permission';

import ActionMenu from './ActionMenu';

const { useState, useActions } = createNamespacedHelpers('cashLog');
const { useState: useAppState } = createNamespacedHelpers('app');

export default {
  components: {
    ActionMenu,
    Pagination
  },
  setup() {
    const { items, filters, total } = useState(['items', 'filters', 'total']);
    const { getCashClosureList, applyFilter, reset } = useActions(['getCashClosureList', 'applyFilter', 'reset']);
    const { isDesktop } = useAppState(['isDesktop']);

    const changePage = (value) => {
      applyFilter({
        page: value,
      });
    };

    const getItems = async () => {
      getCashClosureList();
    };

    const changePageSize = (value) => {
      applyFilter({
        pageSize: value,
        page: 1,
      });
    };

    const isHeadAccountant = computed(() => hasPermissions([PERMISSIONS.HEAD_ACCOUNTANT_ACCESS]));

    watch(filters, () => getItems());

    onMounted(() => {
      getItems();
    });

    onUnmounted(() => {
      reset();
    });

    return {
      items,
      moment,
      DATE_FORMAT,
      getItems,
      addCommas,
      filters,
      total,
      changePageSize,
      changePage,
      isHeadAccountant,
      isDesktop,
    };
  }
};
</script>

<style lang="scss">
@import "~@/assets/scss/colors";

#cash-log-closure-list {
  .list {
    margin-bottom: 20px;

    table {
      width: 100%;
      border-collapse: inherit;
      border-spacing: 0;

      thead {
        text-transform: uppercase;
        font-weight: bold;
        text-align: center;

        tr {
          background-color: $babyPowder;

          th {
            padding: 15px 10px;
            border-top: 1px solid $alto;
            border-bottom: 1px solid $alto;

            &:first-child {
              border-top-left-radius: 3px;
              border-bottom-left-radius: 3px;
              border-left: 1px solid $alto;

            }

            &:last-child {
              border-top-right-radius: 3px;
              border-bottom-right-radius: 3px;
              border-right: 1px solid $alto;
            }

            &.more {
              width: 50px;
            }
          }
        }
      }

      tbody {
        text-align: center;

        tr {
          background-color: $babyPowder;
          cursor: default;

          td {
            padding: 15px 5px;
            border-top: 1px solid $alto;
            border-bottom: 1px solid $alto;

            &:first-child {
              border-top-left-radius: 3px;
              border-bottom-left-radius: 3px;
              border-left: 1px solid $alto;
              color: $geranium;
            }

            &:last-child {
              border-top-right-radius: 3px;
              border-bottom-right-radius: 3px;
              border-right: 1px solid $alto;
            }
          }
        }
      }
    }
    @media (max-width: 991px) {
      table {
        width: auto;
        display: block;

        thead {
          display: block;
        }

        tbody {
          text-align: start;
          display: block;

          tr {
            display: block;
            border-top: 1px solid $alto;
            border-bottom: 1px sold $alto;

            &:nth-child() {
              background-color: grey;
            }

            td {
              padding: 5px;
              display:block;
              border: none;
              position: relative;
              padding-left: 45%;
              min-height: 30px;


              &::before {
                position: absolute;
                top: 0;
                left: 6px;
                width: 45%;
                padding-right: 10px;
                white-space: nowrap;
                text-align: center;
              }

              .mobile-header {
                position: absolute;
                left: 6px;
                padding-right: 10px;
                white-space: nowrap;
                text-align: start;
                padding-left: 10px;
                width: 133px;
              }

              .wrap {
                word-wrap: break-word;
              }

              &:first-child {
                border: 0;
                padding-top: 20px;
              }

              &:last-child {
                border: 0;
                padding-bottom: 20px;
              }
            }
          }
        }
      }
    }
  }

}
</style>
